import React, { useEffect, useRef, useState } from "react";
import { toast } from "react-toastify";
import PhotoCameraIcon from "@mui/icons-material/PhotoCamera";
import {
  Box,
  Grid,
  Avatar,
  Button,
  Divider,
  IconButton,
  CircularProgress,
} from "@mui/material";

import WorkDetails from "./WorkDetails";
import AddressDetails from "./AddressDetails";
import PersonalInformation from "./PersonalInformation";
import { esignToolApi } from "../../../services/esignApi";

const MyProfileData = () => {
  const fileInputRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    address: "",
    pinCode: "",
    city: "",
    country: "",
    state: "",
    profile_picture: ""
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const submitHandler = async () => {
    setLoading(true);
    try {
      const response = await esignToolApi.updateUserProfileData(formData);
      toast.success("Profile updated successfully!");
    } catch (err) {
      console.error("Error:", err);
      toast.error(err.response?.data?.msg || "Error updating profile");
    } finally {
      setLoading(false);
    }
  };

  const getProfileData = async () => {
    try {
      const response = await esignToolApi.getUserProfileData();
      const { profile } = await response.data;
      setFormData(profile);
    } catch (err) {
      console.log("err", err);
    }
  };

  const handleIconClick = () => {
    fileInputRef.current.click();
  };

  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    console.log(file)
    const profileformData = new FormData();
    profileformData.append("profile_picture", file);

    try {
      const response = await esignToolApi.updateUserProfilePicture(profileformData);
      await getProfileData();
    } catch (err) {
      console.error("Error uploading file:", err);
    }
  };

  useEffect(() => {
    getProfileData();
  }, []);

  return (
    <Box
      sx={{
        width: "calc(100% - 256px)",
        overflow: "auto",
        pl: "30px",
        pr: "30px",
      }}
    >
      <Grid container spacing={3} sx={{ height: "calc(100% - 50px)" }}>
        <Grid item xs={12} display="flex" alignItems="flex-start">
          <Box position="relative" sx={{ pt: "26px", mr: 3 }}>
            <Avatar
              sx={{ width: 100, height: 100 }}
              alt="Profile Picture"
              src={formData?.profile_picture}
            />
            <IconButton
              sx={{
                position: "absolute",
                bottom: 0,
                right: 0,
                backgroundColor: "#4285F4",
                color: "white",
                "&:hover": {
                  backgroundColor: "#3367D6",
                },
              }}
              onClick={handleIconClick}
            >
              <PhotoCameraIcon />
            </IconButton>
            <input
              type="file"
              accept="image/*"
              ref={fileInputRef}
              onChange={handleFileChange}
              style={{ display: "none" }}
            />
          </Box>

          <Box sx={{ pt: "30px", pl: "15px", flexGrow: 1 }}>
            <PersonalInformation
              formData={formData}
              handleChange={handleChange}
            />
            <AddressDetails formData={formData} handleChange={handleChange} />
            {/* <WorkDetails formData={formData} handleChange={handleChange} /> */}
          </Box>
        </Grid>
      </Grid>
      <Divider />
      <Box sx={{ textAlign: "end" }}>
        <Button
          disabled={loading}
          variant="contained"
          sx={{
            mt: 2,
            mb: 2,
            height: 40,
            color: "#fff",
            width: "155px",
            fontSize: "16px",
            boxShadow: "none",
            fontWeight: "500",
            borderRadius: "10px",
            background: "#185CB7",
            textTransform: "none",
            "&:hover": { background: "#185CB7" },
          }}
          onClick={submitHandler}
        >
          {loading ? (
            <CircularProgress size={24} sx={{ color: "#fff" }} />
          ) : (
            "Update"
          )}
        </Button>
      </Box>
    </Box>
  );
};

export default MyProfileData;
